import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/user/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../services/user/users.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-loyalty-index',
  templateUrl: './loyalty-index.component.html',
  styleUrls: ['./loyalty-index.component.css']
})
export class LoyaltyIndexComponent implements OnInit {

  columsTitles: any;
  recType: string;
  esempio: any;
  loyals: any;

  constructor(
    private userService: UsersService,
    private translate: TranslateService,
    private srvNotify: MessageService,
    private authService: AuthService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-index/loyalty-index.component.ts